import { LayoutGrid } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const GridIcon = DeckardIconWrapper({ Icon: LayoutGrid });
